import { navegacion } from './navegacion'

export const all = {
    gNavegacion: navegacion
}